var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".mask_svg__st2{fill:#002677}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.314 17.174h23.404v13.652H12.314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.669 18.169v-2.945H10.364v2.945h-.02c-3.159 0-5.84 2.613-5.84 5.831 0 3.228 2.681 5.841 5.84 5.841h.02v2.935h27.305v-2.935c3.15-.01 5.821-2.623 5.821-5.841 0-3.208-2.672-5.822-5.822-5.831zM10.364 27.89h-.02c-2.106 0-3.89-1.785-3.89-3.891s1.784-3.881 3.89-3.881h.02v7.772zm25.354 2.935H12.314V17.174h23.404v13.652zm1.95-2.935v-7.772c2.097.01 3.872 1.784 3.872 3.881 0 2.097-1.775 3.881-3.871 3.89z",
    fill: "#ff612b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mask_svg__st2",
    d: "M30.843 22.537H17.191a.975.975 0 110-1.95h13.652a.975.975 0 010 1.95zM30.843 27.413H17.191a.975.975 0 110-1.95h13.652a.975.975 0 010 1.95z"
  }))));
}
export default SvgMask;